import React, { useState, useEffect } from "react";
import { adminService } from "../../services/api";
import AdsManager from "./AdsManager";

const SettingsTab = ({ onSuccess, onError }) => {
  const [settings, setSettings] = useState({
    header_banner: "",
    landing_banners: [],
    buy_guide_order_link: "",
  });
  const [loading, setLoading] = useState(false);
  const [previewHeader, setPreviewHeader] = useState("");

  useEffect(() => {
    fetchSettings();
  }, []);

  const fetchSettings = async () => {
    try {
      setLoading(true);
      const data = await adminService.getSettings();
      
      let parsedLandingBanners = [];
      if (data?.landing_banners) {
        try {
          parsedLandingBanners = JSON.parse(data.landing_banners);
        } catch (e) {
          // Fallback if it was a single string from previous version
          parsedLandingBanners = [data.landing_banners];
        }
      } else if (data?.landing_banner) {
         parsedLandingBanners = [data.landing_banner];
      }

      setSettings({ 
        header_banner: data?.header_banner || "", 
        landing_banners: parsedLandingBanners,
        buy_guide_order_link: data?.buy_guide_order_link || ""
      });
      setPreviewHeader(data?.header_banner || "");
    } catch (err) {
      onError("Lỗi khi tải cấu hình");
    } finally {
      setLoading(false);
    }
  };

  const handleHeaderUpload = async (e) => {
    const file = e.target.files[0];
    if (!file) return;

    try {
      setLoading(true);
      const url = await adminService.uploadSettingImage(file);
      setSettings({ ...settings, header_banner: url });
      setPreviewHeader(url);
      onSuccess("Tải ảnh lên thành công! Hãy nhấn Lưu để áp dụng.");
    } catch (err) {
      onError("Lỗi khi tải ảnh");
    } finally {
      setLoading(false);
    }
  };

  const handleLandingUpload = async (e) => {
    const file = e.target.files[0];
    if (!file) return;

    if (settings.landing_banners.length >= 10) {
      onError("Chỉ được upload tối đa 10 ảnh.");
      return;
    }

    try {
      setLoading(true);
      const url = await adminService.uploadSettingImage(file);
      const newBanners = [...settings.landing_banners, url];
      setSettings({ ...settings, landing_banners: newBanners });
      onSuccess("Tải ảnh lên thành công! Hãy nhấn Lưu để áp dụng.");
    } catch (err) {
      onError("Lỗi khi tải ảnh");
    } finally {
      setLoading(false);
    }
  };

  const handleRemoveLandingBanner = (index) => {
    const newBanners = [...settings.landing_banners];
    newBanners.splice(index, 1);
    setSettings({ ...settings, landing_banners: newBanners });
  };

  const handleSave = async () => {
    try {
      setLoading(true);
      const payload = {
        header_banner: settings.header_banner,
        landing_banners: JSON.stringify(settings.landing_banners),
        buy_guide_order_link: settings.buy_guide_order_link
      };
      await adminService.saveSettings(payload);
      onSuccess("Lưu cấu hình thành công!");
    } catch (err) {
      onError("Lỗi khi lưu cấu hình");
    } finally {
      setLoading(false);
    }
  };

  if (loading && !settings.header_banner && settings.landing_banners.length === 0) {
    return <div>Đang tải...</div>;
  }

  return (
    <div className="tab-content">
      <h2>Cài đặt Giao diện & Banner</h2>
      
      <div className="form-section">
        <h3>1. Ảnh Nền Landing Page (Trang Đích)</h3>
        <p style={{ color: "#666", marginBottom: "15px" }}>
          Bạn có thể upload tối đa 10 ảnh. Mỗi lần khách hàng truy cập, hệ thống sẽ tự động chọn 1 ảnh ngẫu nhiên để hiển thị toàn màn hình. Kích thước khuyến nghị: 1920x1080.
        </p>
        
        <div style={{ display: "flex", flexWrap: "wrap", gap: "15px", marginBottom: "15px" }}>
          {settings.landing_banners.map((url, idx) => (
            <div key={idx} style={{ position: "relative", width: "200px" }}>
              <img 
                src={url} 
                alt={`Landing Banner ${idx + 1}`} 
                style={{ width: "100%", height: "120px", objectFit: "cover", borderRadius: "8px", border: "1px solid #ccc" }} 
              />
              <button 
                onClick={() => handleRemoveLandingBanner(idx)}
                style={{ position: "absolute", top: "5px", right: "5px", background: "rgba(255,0,0,0.8)", color: "white", border: "none", borderRadius: "50%", width: "24px", height: "24px", cursor: "pointer", display: "flex", alignItems: "center", justifyContent: "center" }}
              >
                ✕
              </button>
            </div>
          ))}
        </div>

        {settings.landing_banners.length < 10 && (
          <div className="form-group">
            <input 
              type="file" 
              accept="image/*" 
              onChange={handleLandingUpload} 
              disabled={loading}
              id="landing-upload"
              style={{ display: "none" }}
            />
            <label htmlFor="landing-upload" className="btn btn-outline" style={{ display: "inline-block", cursor: "pointer" }}>
              + Thêm Ảnh Mới ({settings.landing_banners.length}/10)
            </label>
          </div>
        )}
        </div>

        {/* Link Đặt Mua */}
        <div className="admin-form-group">
          <label>Link Đặt Mua (Dùng cho nút Đặt Mua ở trang chi tiết xe & trang Hướng dẫn)</label>
          <input
            type="text"
            className="admin-input"
            placeholder="Nhập URL (VD: https://reserve.vinfastauto.com/...)"
            value={settings.buy_guide_order_link}
            onChange={(e) => setSettings({ ...settings, buy_guide_order_link: e.target.value })}
          />
          <small>Khi người dùng bấm "Đặt mua", hệ thống sẽ chuyển hướng hoặc mở link này.</small>
        </div>

        <div className="settings-actions" style={{ marginTop: "30px", borderTop: "1px solid #eee", paddingTop: "20px" }}>
        <h3>2. Ảnh Nền Header (Thanh Điều Hướng)</h3>
        <p style={{ color: "#666", marginBottom: "15px" }}>
          Ảnh này sẽ hiển thị ở đằng sau các menu trên tất cả các trang phụ. Kích thước khuyến nghị: 1920x200.
        </p>
        {previewHeader && (
          <img 
            src={previewHeader} 
            alt="Header Banner" 
            style={{ width: "100%", maxHeight: "100px", objectFit: "cover", borderRadius: "8px", marginBottom: "15px" }} 
          />
        )}
        <div className="form-group">
          <input 
            type="file" 
            accept="image/*" 
            onChange={handleHeaderUpload} 
            disabled={loading}
          />
        </div>
      </div>

      <AdsManager onSuccess={onSuccess} onError={onError} />

      <button 
        className="btn btn-primary" 
        onClick={handleSave}
        disabled={loading}
        style={{ marginTop: "20px", padding: "12px 30px" }}
      >
        {loading ? "Đang lưu..." : "Lưu Cài Đặt"}
      </button>
    </div>
  );
};

export default SettingsTab;
